import React, { useState } from 'react';
import Modal from 'react-modal';
import {
  EmailShareButton,
  EmailIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinIcon,
  FacebookIcon,
} from 'react-share';
import { FaShareAlt, FaSms } from 'react-icons/fa'; // Import a custom SMS icon or use any other library
import { useTranslation } from 'react-i18next';
import useIsMobile from '../../hooks/Helper/useIsMobile';
import { QRCode } from 'react-qrcode-logo';
import { handleCredentialShareButtonClick } from '../../tools/utils';
import { analyticsService } from '../../services/analyticsService';



Modal.setAppElement('#root');

interface ShareModalProps {
  CCOID: string;
  Name: string;
}

const CredentialShare: React.FC<ShareModalProps> = ({ CCOID, Name }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState('');
      const { t } = useTranslation();

      const isMobile=useIsMobile();

  const shareUrl = process.env.REACT_APP_BASE_URL === "https://my.ccocert.org/"
    ? `https://verifycco.org/cred/${CCOID}`
    : `https://stg1995.verifycco.org/cred/${CCOID}`;
  const shareMessage = t("testingPersonnel.shareModal.shareMessage", { 
    name: Name, 
    url: shareUrl 
  });
  const shareTitle = t("testingPersonnel.shareModal.shareSubject", {
    name: Name
  });
  const socialPostText = `I'm proud to share that I'm a credentialed practical proctor through CCO Certification!
#CCOCertification #GoldStandard`;

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopySuccess(t("testingPersonnel.shareModal.copiedMessage"));
      setTimeout(() => setCopySuccess(''), 2000);
    });
  };

  const handleSmsClick = () => {
    analyticsService.handleVCO_Cred_SMSClicked(); // Track SMS click for certification sharing
    window.location.href = `sms:?&body=${encodeURIComponent(shareMessage)}`;
  };

  return (
    <div>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleCredentialShareButtonClick();
          openModal();
        }}
        style={{
          width: '100%',
          marginLeft: '10px',
          height: '40px',
          padding: '10px',
          backgroundColor: '#c67b05',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-around',
        }}
      >
       <FaShareAlt />{t("testingPersonnel.shareModal.shareButton")} 
      </a>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Share Modal"
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 20px', 

          },
          content: {
            position: 'relative',
            width: '400px',
            padding: '20px',
            borderRadius: '8px',
            inset: 'unset',
            backgroundColor: 'white',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          },
        }}
      >
        <button
          onClick={closeModal}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            cursor: 'pointer',
            border: 'none',
            background: 'transparent',
            fontSize: '1.5rem',
          }}
        >
          &#10005;
        </button>

        <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>{t("testingPersonnel.shareModal.title")}</h2>

        <div style={{ display: 'flex', gap: '15px',flexWrap:"wrap", marginBottom: '20px', justifyContent: 'center' }}>
        <EmailShareButton url={''} subject={shareTitle} body={shareMessage} onClick={()=>{
                  analyticsService.handleVCO_Cred_EmailClicked();
                  window.location.href = `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareMessage)}`;
                }}>
            <EmailIcon size={40}  round/>
          </EmailShareButton>
        {isMobile && 
        <button style={{ backgroundColor: 'transparent',color: 'gray',marginLeft: '', border: 'none', cursor: 'pointer' }}
        onClick={handleSmsClick}
        >
          <FaSms size={40} />
        </button>
        }  
          <WhatsappShareButton  url={shareMessage}
          onClick={()=>{analyticsService.handleVCO_Cred_WhatsAppClicked();}}>
            <WhatsappIcon size={40} round />
          </WhatsappShareButton>
          <button
            title="Share on LinkedIn"
            onClick={() => {
              analyticsService.handleVCO_Cred_LinkedInClicked();
              const desktopUrl = `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(socialPostText + '\n' + shareUrl)}`;
              const mobileUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent('CCO Certification')}&summary=${encodeURIComponent(socialPostText)}`;
              
              if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
                window.location.href = mobileUrl;
              } else {
                window.open(desktopUrl, '_blank', 'width=600,height=600');
              }
            }}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <LinkedinIcon size={40} round />
          </button>
          <button
            title="Share on Facebook"
            onClick={() => {
              analyticsService.handleVCO_Cred_FacebookClicked();
              const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(socialPostText)}`;
              if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                window.open(fbUrl, '_blank');
              } else if (/Android/i.test(navigator.userAgent)) {
                window.location.href = fbUrl;
              } else {
                window.open(fbUrl, '_blank', 'width=600,height=600');
              }
            }}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <FacebookIcon size={40} round />
          </button>
        </div>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
      <QRCode logoImage='/CCOlogo_metallic.png' logoWidth={40} logoHeight={40} value={shareUrl} size={120} qrStyle='dots' />
      </div>  

        {/* Input and Copy Button Container */}
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <input
            type="text"
            value={shareUrl}
            readOnly
            style={{
              width: '100%',
              padding: '10px',
              paddingRight: '80px', // Space for the button
              borderRadius: '10px',
              border: '2px solid whitesmoke',
            }}
          />
          <button
            onClick={copyToClipboard}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              padding: '6px 10px',
              backgroundColor: '#c67b05',
              color: 'white',
              border: 'none',
              borderRadius: '20px',
              cursor: 'pointer',
            }}
          >
            {t("testingPersonnel.shareModal.copyButton")}
          </button>
        </div>

        {copySuccess && (
          <p style={{ color: 'green', fontSize: '0.9rem', textAlign: 'center' }}>{copySuccess}</p>
        )}
      </Modal>
    </div>
  );
};

export default CredentialShare;
